module.exports = __webpack_public_path__ + "img/pos4_banner.0f439300.png";